import { useEffect, useCallback, useState, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { showModal, disableInputs, ineligibleMessage } from '../Helpers/FormHelper';
import { ModalPopup } from '../common/ModalPopup';
export function QuestionInfo({ finalAmount, setQuestions, questions }) {
  const [error, setError] = useState();
  const [popupMessage, setPopupMessage] = useState("");
  const [popupTitle, setPopupTitle] = useState("");
  const [modal, setModal] = useState(false);
  const finalAmountRef = useRef(finalAmount); // ref prevents re-rendering when finalAmount changes

  //callback here to prevent re-renders
  const renderQuestions = useCallback((data) => {
    setQuestions(data);
  }, [setQuestions]);

  useEffect(() => {
    console.log('component mounted!');
    const populateQuestions = async () => {
      let amount = finalAmountRef;
      if (isNaN(amount)) {
        amount = "1";
      }

      await axios.get(`/question/questionsbyamount/${amount}`)
        .then((response) => {
          if (response.data != null) {
            renderQuestions(response.data);
          }
        }).catch(function (error) {
          let errorMessage = `Error: ${error.message}`;
          if (error.response) {
            errorMessage += `\nStatus Code: ${error.response.status}\nRoute: ${error.response.config.url}`;
          }
          setError(errorMessage);
        });
    }
    populateQuestions();
  }, [renderQuestions])

  const questionValueChange = (e) => {
    const { name, value } = e.target;
    let questionsCopy = [...questions];
    const nameSplit = name.split('-');
    let id = parseInt(nameSplit[1]);

    let question = questionsCopy.find(q => q.id === id);
    question.selectedAnswer = value;
    setQuestions(questionsCopy);

    if (name === "question-1" && value === "Yes") {
      disableInputs(true);
      setPopupTitle(`Ineligible Donation`);
      setPopupMessage(ineligibleMessage());
      showModal(e, setModal, true);
    } else {
      disableInputs(false);
    }
  };

  const extraQuestions = () => {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <h2>Certifications</h2>
          </div>
        </div>
        {questions.map((question, i) => (
          <div key={i}>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div>{question.questionText}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="form-group">
                  <div className="radio">
                    <label className="control-label">
                      <input type="radio" name={`question-${question.id}`} id={`questionDecline${question.id}`} value={`${question.questionDeclineText}`} onChange={questionValueChange} />
                      {question.questionDeclineText}
                    </label>
                  </div>
                  <div className="radio">
                    <label className="control-label">
                      <input type="radio" name={`question-${question.id}`} id={`questionAccept${question.id}`} value={`${question.questionAcceptText}`} onChange={questionValueChange} />
                      {question.questionAcceptText}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <ModalPopup message={popupMessage} title={popupTitle} setModal={setModal} modal={modal} />
      </div>
    );
  }

  if (error) {
    return <h2><b>Problem loading questions: {error}</b></h2>
  } else {
    return (
      <div>
        {extraQuestions()}
      </div>
    );
  }
}

QuestionInfo.propTypes = {
  finalAmount: PropTypes.string,
  setQuestions: PropTypes.func,
  questions: PropTypes.array,
}
